import React from "react"
import { FaEnvelope, FaLocationArrow, FaPhone } from "react-icons/fa"

const ContactData = [
  { text: "123 Ibom Plaza, Uyo", icon: <FaLocationArrow /> },
  { text: ["+1234567890", "+9876543210"], icon: <FaPhone /> },
  { text: "info@jsxconstruction.com", icon: <FaEnvelope /> },
]

export default ContactData
